import { Box, Card, CollapsableCard, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { BoxedCallout } from 'modules/performance_process/components/common/BoxedCallout'

interface Props {
  value: boolean
  disabled?: boolean
  title: string
  description?: string
  onChange: (value: boolean) => void
  checkboxAriaLabel?: string
  infoCalloutDescription?: string
  CollapsableContent?: React.ReactNode
}

export const SettingsToggle: React.FC<Props> = ({
  title,
  description,
  value,
  disabled,
  checkboxAriaLabel,
  infoCalloutDescription,
  CollapsableContent,
  onChange,
}) => (
  <CollapsableCard
    open={Boolean(value && CollapsableContent)}
    contentPadding="s16"
    Card={
      <Box onClick={disabled ? undefined : () => onChange(!value)} paddingX="s8" gap="s8">
        <Card.Title
          size="small"
          action={
            <TogglerCheckbox
              value={value}
              onChange={() => {}}
              disabled={disabled}
              aria-label={checkboxAriaLabel}
            />
          }
        >
          {title}
        </Card.Title>
        {description !== undefined && <Card.Description>{description}</Card.Description>}
        {infoCalloutDescription !== undefined && (
          <Card.Content>
            <BoxedCallout fullWidth description={infoCalloutDescription} />
          </Card.Content>
        )}
      </Box>
    }
    Content={CollapsableContent ? <Box paddingX="s8">{CollapsableContent}</Box> : undefined}
  />
)
